import { effect, Injectable, signal, WritableSignal } from '@angular/core';
import { ShiftRequest } from '@interfaces/data/shift-request';
import { Shift } from '@interfaces/data/shift';

@Injectable({
  providedIn: 'root',
})
export class ShiftService {
  shiftRequests = signal<ShiftRequest[]>([]) as WritableSignal<ShiftRequest[]>;
  shifts = signal<Shift[]>([]) as WritableSignal<Shift[]>;

  constructor() {
    effect(() => {
      let mappedShifts = this.mapShifts(this.shiftRequests());
      this.shifts.set(mappedShifts ?? []);
    });
  }

  updateShift(updatedShift: Shift) {
    const shifts = this.shifts();
    const updatedShifts = shifts!.map((shift) => {
      if (shift.id === updatedShift.id) {
        return updatedShift;
      }
      return shift;
    });
    this.shifts.set(updatedShifts);
  }

  mapShifts(shifts: ShiftRequest[] | undefined) {
    const mapStringToTime = (
      input: string,
    ): { hour: number; minute: number } => {
      const strings = input.split(':');
      const hour = Number(strings[0]);
      const minute = Number(strings[1]);
      return {
        hour,
        minute,
      };
    };

    return shifts?.map((shift) => {
      return {
        ...shift,
        startTime: mapStringToTime(shift.startTime),
        endTime: mapStringToTime(shift.endTime),
      };
    });
  }
}
